import { render, staticRenderFns } from "./AcknowledgmentPipelinePage.vue?vue&type=template&id=1b96c48a&scoped=true"
import script from "./AcknowledgmentPipelinePage.vue?vue&type=script&lang=js"
export * from "./AcknowledgmentPipelinePage.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgmentPipelinePage.vue?vue&type=style&index=0&id=1b96c48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96c48a",
  null
  
)

export default component.exports